import Resource from '@/services/resources/common';

// question type
export default class CalculationsResource extends Resource {
  constructor(entrypoint = '/calculations', alias = 'Calculation') {
    super(entrypoint, alias);
  }
}
